import type { EditorialCategory } from "../../../../api/editorialCategories.service";
import type { PracticeOption } from "./types.js";

type PracticeCategory = EditorialCategory & {
  practiceGroup?: string | null;
  practiceArea?: string | null;
  tableName?: string | null;
  practiceAreaId?: number | null;
  tableId?: number | null;
};

// Builds "practiceGroup > practiceArea > tableName" removing consecutive
// duplicates (e.g. "Corporate > Corporate"). Mirrors ContentInbox exactly.
export function buildPracticeLabel(cat: PracticeCategory): string {
  const parts: string[] = [];
  if (cat.practiceGroup) parts.push(cat.practiceGroup);
  if (cat.practiceArea) parts.push(cat.practiceArea);
  if (cat.tableName) parts.push(cat.tableName);

  const deduped: string[] = [];
  for (const part of parts) {
    if (deduped.length === 0 || deduped[deduped.length - 1] !== part) {
      deduped.push(part);
    }
  }

  if (deduped.length === 0) return `Practice ${cat.id}`;
  if (deduped.length === 1) return deduped[0];
  return deduped.join(" > ");
}

// Maps raw practice-area editorial categories to sorted PracticeOptions.
export function toPracticeOptions(categories: EditorialCategory[]): PracticeOption[] {
  return categories
    .map((cat, index): PracticeOption => {
      const ec = cat as PracticeCategory;
      return {
        key: `${ec.id}:${index}`,
        // The table is the lowest level of the hierarchy: when a row denormalizes
        // both a table and its parent practice area, the table's own id is the
        // true editorial_category_id, taking precedence over the parent id.
        editorialCategoryId: ec.tableId ?? ec.id,
        practiceAreaId: ec.practiceAreaId ?? null,
        practiceAreaName: ec.practiceArea ?? null,
        tableId: ec.tableId ?? null,
        tableName: ec.tableName ?? null,
        label: buildPracticeLabel(ec),
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label));
}
